import React, { useEffect } from 'react'
import { useTopMenuOpen } from './topMenuContext'
import { INIT_TITLE } from '../../configurations/initUrls'
import { Link } from 'react-router-dom'
import moment from 'moment'
import FooterInner from './FooterInner'

export default function Container({ children, bg = "", title = "" }) {
    const [isTopMenuOpen, changeTopMenu, closeTopMenu] = useTopMenuOpen()
    useEffect(() => {
        document.title = (title ? title + " | " : "") + INIT_TITLE
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }, [])

    return (
        <>
            <div className='min-h-screen flex flex-col justify-between'>
                <div onClick={() => closeTopMenu()} class={"p-4 pt-[70px] " + bg}>
                    <div class={"h-full pt-2 sm:px-4"}>
                        <div class="h-full md:flex no-wrap md:-mx-2 ">
                            {children}
                        </div>
                    </div>
                </div>
                <section>
                    <FooterInner />
                </section>
            </div>
        </>
    )
}
